import React from 'react'

function OtherPage() {
  return (
    <h1>OtherPage</h1>
  )
}

export default OtherPage